import { Form, ConfigProvider, Input } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'translations/hooks';

import { ShiftOrCalendarSelector } from 'business/production-and-performance/components/shift-or-calendar-selector';
import {
  useProdAndPerfFilters,
  useProdAndPerfFiltersFormName,
} from 'business/production-and-performance/providers/prod-and-perf-filters-provider';
import { PreselectTemporalSelectInput } from 'ui/form/preselect-date-select-input';

export interface RingPerDayMobileFilterProps {}

export const RingPerDayMobileFilter = ({}: RingPerDayMobileFilterProps) => {
  const { t } = useTranslation();
  const formName = useProdAndPerfFiltersFormName();
  const filters = useProdAndPerfFilters();
  const [form] = Form.useForm();

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            inlineItemMarginBottom: 12,
          },
        },
      }}
    >
      <Form layout="inline" form={form} name={formName} initialValues={filters}>
        <Form.Item name="filterType" hidden>
          <Input disabled />
        </Form.Item>
        <Form.Item name="dateRange" label={t('input.dateRange.label')}>
          <PreselectTemporalSelectInput mode="date" defaultDate={dayjs()} />
        </Form.Item>

        <Form.Item label={t('input.filterByOptions.startOfDay')} name="dayMode">
          <ShiftOrCalendarSelector />
        </Form.Item>
      </Form>
    </ConfigProvider>
  );
};
